module.exports = __webpack_public_path__ + "static/img/place.4854e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/place.png
// module id = wtJD
// module chunks = 1